var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "boards" },
    [
      _vm._v("Οι επιτροπές μου\n  "),
      _c(
        "el-select",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.boardsLoading,
              expression: "boardsLoading"
            }
          ],
          attrs: {
            "active-text-color": "#ffd04b",
            placeholder: "Επιλέξτε Επιτροπή"
          },
          on: { change: _vm.fetchAssignedApplications },
          model: {
            value: _vm.boardSelected,
            callback: function($$v) {
              _vm.boardSelected = $$v
            },
            expression: "boardSelected"
          }
        },
        _vm._l(_vm.assignedExecutiveBoards, function(board) {
          return _c("el-option", {
            key: board.boardsId,
            attrs: {
              label: board.boardsId + " " + "-" + " " + board.boardsTitle,
              value: board.boardsTitle
            }
          })
        })
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0684bc0b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0684bc0b","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/roleSpecific/ExecutiveBoardMemberMenu.vue
// module id = null
// module chunks = 